import { render, staticRenderFns } from "./matchList.vue?vue&type=template&id=67f765ea&scoped=true&"
import script from "./matchList.vue?vue&type=script&lang=js&"
export * from "./matchList.vue?vue&type=script&lang=js&"
import style0 from "./matchList.vue?vue&type=style&index=0&id=67f765ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f765ea",
  null
  
)

export default component.exports